import { Grid, Typography } from '@mui/material';
import React from 'react';
import { formatDate } from '../utils/formatDate';

export const Data: React.FC<{
  type?: string;
  label: string;
  content: string | null;
  data?: any;
}> = ({ type, label, content, data }) => {
  return (
    <Grid container spacing={{ xs: 1, sm: 1, md: 0, lg: 0 }}>
      <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6 }}>
        <Typography textAlign={'start'} variant="body2" color="text.secondary">
          {label}
        </Typography>
      </Grid>
      <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6 }}>
        {type === 'date' ? (
          <Typography textAlign={'start'} variant="body2" color="text.primary">
            {formatDate(content)}
          </Typography>
        ) : type === 'component' ? (
          data.element?.(data) || data
        ) : (
          <Typography textAlign={'start'} variant="body2" color="text.primary">
            {content || '-'}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};
